export const STATUS = {
  IN_PROGRESS: 'in_progress',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAIL: 'fail',
  ARCHIVED: 'archived'
}
